import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import "./CustomTabsStyles.scss"

const CustomTab = withStyles((theme) => ({
  wrapper: {
    flexDirection: "row",
  },
}))((props) => <Tab className="customTab" {...props} />);


export default CustomTab;
